import DirectoryCluster from "../../components/DirectoryCluster/DirectoryCluster";

const DirectoryPageDark = () => {
  return (
    <DirectoryCluster title="Links" list={[
      {title: "Website", iconClass: "fa-solid fa-laptop", url: "/"},
      {title: "Instagram", iconClass: "fa-brands fa-instagram", url: "https://www.instagram.com/rosebornefilmandphoto/"},
      // {title: "Youtube", iconClass: "fa-brands fa-youtube", url: "https://www.youtube.com"}
    ]} light={false} />
  );
}; 

// const DirectoryCluster= (title, list =[]) => {
//   return (
//     <div className="bg-dark flex-column-centered" style={{height:"100vh"}} >
//       <BoldText clr="clr-dark-red" marginClass={"margin-bottom-5"} class_Name="font-size-6" > Links</BoldText>
//       <div className="flex-column-centered" style={{width:"85%"}} >
//         <DirectoryButton title="Website" iconClass="fa-solid fa-laptop" light={false} />
//         <DirectoryButton title="Website" iconClass="fa-solid fa-laptop" light={false} />
//         <DirectoryButton title="Website" iconClass="fa-solid fa-laptop" light={false} />
//       </div>
//     </div>
//   );
// }; 


export default DirectoryPageDark;